import { NgModule } from '@angular/core';
import { CommonModule, NgComponentOutlet } from '@angular/common';
import { ModalWrapperComponent } from './modal-wrapper.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalWrapperService } from './modal-wrapper.service';



@NgModule({
  declarations: [ModalWrapperComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    NgComponentOutlet,
  ],
  exports: [ModalWrapperComponent],
  providers: [ModalWrapperService],
})
export class ModalWrapperModule {}
